module.exports = __webpack_public_path__ + "img/velopub.a213961f.jpg";